import { searchProducts } from "@/utils/productSearch";

// Cada hit trae en price_and_stock_by_store, por código de departamento, el
// precio de los niveles que ve el usuario, totalStock y stockByWarehouse.

// La misma búsqueda que part-search y el buscador de la orden, sin facets.
// Con un vehículo elegido cada hit lleva _fits (su fitment incluye el
// vehículo) y, con filterByVehicle, sólo salen los que le quedan: el mismo
// filtro por ids de aplicación que el chip de vehículo de part-search.
export const searchCatalog = (
  ctx,
  query,
  hitsPerPage,
  { filterByVehicle = false } = {}
) => {
  const { vehicle } = ctx.getSelection();
  return searchProducts({
    collection: ctx.collection,
    query,
    hitsPerPage,
    facets: false,
    facetsSelection:
      vehicle && filterByVehicle
        ? [{ type: "vehicle", field: "fitment", values: vehicle.ids }]
        : [],
    verifyFitment: vehicle ? vehicle.ids : null
  }).then(result => result.hits);
};

export const nkrCodeOf = hit => (hit.nkrCode && hit.nkrCode[0]) || hit.objectID;

// Existencias de cada tienda (departamento), la del vendedor primero
export const storesOf = (hit, ctx) =>
  Object.entries(hit.price_and_stock_by_store || {})
    .map(([code, store]) => ({
      code,
      name:
        (ctx.departments.find(department => department.code === code) || {})
          .name || code,
      total: Number(store.totalStock) || 0,
      available: store.available || null,
      warehouses: Object.values(store.stockByWarehouse || {}).map(
        warehouse => ({
          code: warehouse.warehouse_code,
          stock: Number(warehouse.stock) || 0
        })
      )
    }))
    .sort(
      (a, b) =>
        (b.code === ctx.departmentCode) - (a.code === ctx.departmentCode) ||
        a.code.localeCompare(b.code)
    );

// Una opción de la tarjeta. El precio es el online de la tienda del vendedor,
// de referencia: la cotización usa el nivel de precio de su cliente.
export const optionOf = (hit, ctx) => {
  const store = (hit.price_and_stock_by_store || {})[ctx.departmentCode] || {};
  return {
    id: hit.objectID,
    nkrCode: nkrCodeOf(hit),
    title: hit.title,
    brand: hit.brand || null,
    unificado: hit.unificado || null,
    image: hit.image_thumbnail || hit.image_url || null,
    price: Number(store.online) || null,
    stock: Number(store.totalStock) || 0,
    available: store.available || null,
    // Dónde coincidió lo buscado: { label: "OE", values: ["8-97<em>358</em>"] }.
    // Los valores vienen escapados de la API, con <em> en lo que
    // coincidió: seguros para v-html
    matches: (hit._matches || []).map(match => ({
      label: match.label,
      values: match.values
    })),
    // Sin vehículo elegido no se sabe
    fits: typeof hit._fits === "boolean" ? hit._fits : null
  };
};

// Lo que lee Claude de cada opción
export const optionSummary = option => ({
  nkrCode: option.nkrCode,
  title: option.title,
  brand: option.brand,
  priceOnline: option.price,
  stockInSellerStore: option.stock,
  ...(option.fits === null ? {} : { fitsSelectedVehicle: option.fits })
});
